<template>
<div>
  <!-- 密码修改 -->
  <a-modal
    :title="$t('setting.updatePassword')"
    :okText="$t('common.confirm')"
    :cancelText="$t('common.cancel')"
    :keyboard="false"
    :maskClosable="false"
    :closable="false"
    v-model="show"
    @cancel="cancelUpdatePassword"
    @ok="handleUpdatePassword">
    <a-form :form="form">
      <a-form-item
        :label="$t('personal.oldPassword')"
        v-bind="formItemLayout">
        <a-input type="password"
                 autocomplete="false"
                 :placeholder="$t('personal.inputOldPassword')" v-decorator="['oldPassword',{rules: [{ required: true, message: $t('personal.inputOldPassword')}, { validator: this.handleOldPassowrd }], validateTrigger: ['blur']}]"></a-input>
      </a-form-item>
      <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['update-password', passwordLevelClass]">{{ $t('personal.strength') }}<span>{{ passwordLevelName }}</span></div>
            <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor "/>
            <div style="margin-top: 10px;">
              <span>{{ $t('personal.passwordTip') }}</span>
            </div>
          </div>
        </template>
        <a-form-item
          :label="$t('personal.newPassword')"
          v-bind="formItemLayout">
          <a-input type="password"
                   @click="handlePasswordInputClick"
                   autocomplete="false"
                   :placeholder="$t('personal.passwordPlaceholder')" minlength='6' v-decorator="['password',{rules: [{ required: true, message: $t('personal.passwordPlaceholder')}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"></a-input>
        </a-form-item>
      </a-popover>
      <a-form-item
        :label="$t('personal.confirmPassword')"
        v-bind="formItemLayout">
        <a-input type="password" autocomplete="false" minlength='6' :placeholder="$t('personal.confirmPasswordPlaceholder')" v-decorator="['password2',{rules: [{ required: true, message: $t('personal.passwordPlaceholder') }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</div>
</template>
<script>
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}

export default {
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  props: {
    updatePasswordModelVisible: {
      default: false
    },
    user: {
      required: true
    }
  },
  data () {
    return {
      // form: null,
      state: {
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      // oldPassword: '',
      // newPassword: '',
      validateStatus: '',
      help: ''
    }
  },
  computed: {
    // 非中文标签较长，加宽标签列避免输入框遮挡文字
    formItemLayout () {
      const isZh = !this.$i18n || this.$i18n.locale === 'zh-CN'
      return {
        labelCol: { span: isZh ? 4 : 7 },
        wrapperCol: { span: isZh ? 18 : 16 }
      }
    },
    show: {
      get: function () {
        return this.updatePasswordModelVisible
      },
      set: function () {
      }
    },
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      const level = this.state.passwordLevel
      if (level >= 3) {
        return this.$t('personal.levelStrong')
      }
      if (level === 2) {
        return this.$t('personal.levelMedium')
      }
      return this.$t('personal.levelLow')
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    }
  },
  methods: {
    isMobile () {
      return this.$store.state.setting.isMobile
    },
    cancelUpdatePassword () {
      this.state.passwordLevelChecked = false
      this.form.resetFields()
      this.$emit('cancel')
    },
    handleUpdatePassword () {
      this.form.validateFields((err, values) => {
        if (!err) {
          let newPassword = this.form.getFieldValue('password')
           if(newPassword.length < 6){
             this.$message.success(this.$t('personal.minSixChars'))
             return false
           }
          this.$put('user/password', {
            password: this.$aesEncrypt.encrypt(newPassword),
            username: this.user.username
          }).then(() => {
            this.state.passwordLevelChecked = false
            this.$emit('success')
            this.form.resetFields()
          })
        }
      })
    },
    handlePasswordLevel (rule, value, callback) {
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error(this.$t('personal.strengthNotEnough')))
      }
    },
    handlePasswordCheck (rule, value, callback) {
      let password = this.form.getFieldValue('password')
      if (value === undefined) {
        callback(new Error(this.$t('personal.inputPassword')))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error(this.$t('personal.passwordNotMatch')))
      }
      callback()
    },
    handlePasswordInputClick () {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    handleOldPassowrd (rule, value, callback) {
      let password = this.form.getFieldValue('oldPassword')
      if (typeof password !== 'undefined' && password.trim().length) {
        this.$get('user/password/check', {
          password: this.$aesEncrypt.encrypt(password),
          username: this.user.username
        }).then((r) => {
          if (r.data) {
            callback()
          } else {
            callback(new Error(this.$t('personal.oldPasswordIncorrect')))
          }
        })
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang="less">
  .update-password {
    &.error {
      color: #ff0000;
    }
    &.warning {
      color: #ff7e05;
    }
    &.success {
      color: #52c41a;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/UpdatePassword.vue